<template>
  <div
    @click="e => $emit('click', e)"
    class="app-subheader"
    :class="{
      'primary-text-color': primary,
      'secondary-text-color': secondary,
    }"
  >
    <slot />
  </div>
</template>

<script>
export default {
  name: 'AppSubheader',

  props: {
    primary: {
      type: Boolean,
      default: false,
    },

    secondary: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped>
@use 'sass:math';

@use '@/styles/settings.scss' as *;

.app-subheader {
  font-weight: bold;
  margin-bottom: #{math.div($defaultPadding, 2)};

  &:only-child {
    margin-bottom: 0;
  }
}
</style>
